var React = require('react');

function BackendNavigationApi (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#000000","d":"M16 4.414l-1.414-1.414-2.793 2.793-1.586-1.586 2.793-2.793-1.414-1.414-2.793 2.793-1.793-1.793-1.354 1.353 8 8 1.354-1.353-1.793-1.793 2.793-2.793z","key":0}),React.createElement("path",{"fill":"#000000","d":"M12.407 10.528l-6.935-6.935c-1.497 1.795-3.196 4.57-2.022 6.957l-2.066 2.066c-0.486 0.486-0.486 1.282 0 1.768l0.232 0.232c0.486 0.486 1.282 0.486 1.768 0l2.066-2.066c2.387 1.174 5.161-0.524 6.957-2.022z","key":1})]);
}

BackendNavigationApi.displayName = "BackendNavigationApi";

BackendNavigationApi.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = BackendNavigationApi;

BackendNavigationApi.default = BackendNavigationApi;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/backend-navigation-api.svg
// module id = 991
// module chunks = 0